export const hasWindow = (): boolean => typeof window !== 'undefined';
